import React from "react";

const AddMoreButton = ({ onClick }) => {
  return (
    <button className="btn btn-outline-success" onClick={onClick}>
      Add more members
    </button>
  );
};

export default AddMoreButton;
